import { ChangeDetectorRef, Component, OnDestroy, OnInit, } from '@angular/core';
import { Subscription, debounceTime, distinctUntilChanged, } from 'rxjs';
import { FormArray, FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, } from '@angular/router';
import { FORMSI, RESPONSIVEOPTIONSI, WIDGET } from '../../interfaces/page-interface';
import { CATEGORIES_META_DATA, SIDENAV_CONTENTLIST_OPTIONS,SAMPLE_MENUDATA, SAMPLE_NAVDATA } from '../../constants/side-nav.cnst';
import { PAGE, SECTION } from '../../models/app-json';
import { WebServiceService } from '../../services/web-service.service';
import { PAGETYPES } from '../../constants/proj.cnst';
import {GridsterDropService} from '../../services/gridster-drop.service'
import { WebBuilderService } from '../../services/web-builder.service';

@Component({
  selector: "lib-web-sidenav-content-list",
  templateUrl: "./web-sidenav-content-list.component.html",
  styleUrls: ["./web-sidenav-content-list.component.scss"],
})
export class WebSidenavContentListComponent implements OnInit, OnDestroy {
  openedContainers: string[] = [];
  page!: PAGE;
  displayedContent!: string;
  sideNavSubscription!: Subscription;
  displaySubNav: boolean = false;
  colorCtr!: FormGroup;
  panelOpenState = true;
  buttonActions = ["default action", "conditional action", "Api call"];
  selectedActions: string[] = [];
  componentOptions: string[] = ["button", "simple list", "navigation"];
  selectedComponents: SECTION[] = [];
  selectedValidationType!: string;
  validationValue!: string;
  inputFieldValidationData = ["Required", "MinLength", "MaxLength"];
  selectedWidgetTypeConfig!: string;
  isRequiredFormValidation: boolean = false;
  validationForm!: FormGroup;
  selectedWidgetMetaData: any = {};
  selectedColor!: string;
  selectedBgColor!: string;
  openedWidgetForm!: number;
  isClicked: boolean = false;
  categoriesList: { type: string; items: (WIDGET | FORMSI)[] }[] =
    CATEGORIES_META_DATA;
  searchTerm: string = "";
  filteredCategories: { type: string; items: (WIDGET | FORMSI)[] }[] =
    CATEGORIES_META_DATA;
  sideNavContentOptions = SIDENAV_CONTENTLIST_OPTIONS;
  pageTypes = PAGETYPES;
  filteredDefaultPageTemplate: any;
  panelStates: boolean[] = [false, false, false, false, false];
  isFilterApplied: boolean = false;
  selectedSectionData: SECTION = {
    sectionId: "",
    key: "",
    name: "",
    image: "",
    widgets: [],
    isEditable: true,
    showDeleteButton: true,
    sectionType: "",
  };
  widgetId: any;
  sectionIndex: any;
  defPagesData: any = [];
  widgetIndex: any;
  applicationMetaData: any;
  navConfig!: any;
  menuConfig!: any;
  applicationId!: string;
  allPages!: any[];

  navButtonGroup!: FormGroup;
  menuButtonGroup!: FormGroup;
  imageUploaderSrc: string = "../assets/images/image-placeholder.webp";
  constructor(
    private sharedService: WebServiceService,
    private route: ActivatedRoute,
    private gridsterService: GridsterDropService,
    private cdRef: ChangeDetectorRef,
    private _fb: FormBuilder,
    private webBuilderService: WebBuilderService
  ) {}

  ngOnInit() {
    const currentParams = { ...this.route.snapshot.queryParams };
    this.applicationId = currentParams["id"];

    this.menuButtonGroup = this._fb.group({
      pages: this._fb.array([]),
      userInfo: [true, Validators.required],
      logoutOption: [true, Validators.required],
    });

    this.navButtonGroup = this._fb.group({
      selectedOption: ["logo", Validators.required],
      logo: [""],
      title: [""],
      pages: this._fb.array([]),
      userInfo: [true, Validators.required],
      logoutOption: [true, Validators.required],
    });

    this.page = this.sharedService.getSelectedPage();

    this.applicationMetaData = this.sharedService.getApplicationDataById();
    if (
      this.filteredDefaultPageTemplate == undefined ||
      this.filteredDefaultPageTemplate?.lenth == 0
    ) {
    }

    this.getDisplayContent();
    this.sharedService.onMobileScreenDropSubjectdata$.subscribe((data: any) => {
      if (data?.onClick) {
        this.widgetId = data?.data;
        this.sectionIndex = data?.sectionIndex;
        this.widgetIndex = data?.widgetIndex;
        this.selectedWidgetMetaData = data?.widgetMeta;
        this.selectedWidgetTypeConfig = data?.widgetMeta.type;
        this.selectedColor = data?.widgetMeta?.widgetConfig?.style?.color;
        this.selectedBgColor = data?.widgetMeta?.style?.backgroundColor;
      }
    });

    this.sharedService.selectedPageObj$.subscribe((data) => {
      this.page = data;
    });

    this.changeSubscribe();
  }

  get pages() {
    return this.menuButtonGroup.get("pages") as FormArray;
  }

  get navPages() {
    return this.navButtonGroup.get("pages") as FormArray;
  }

  onSubmit(group: FormGroup) {
    if (group.valid) {
      this.page.pageConfig.menuConfig = this.menuButtonGroup.value;
      let pagePostData = {
        applicationId: this.applicationId,
        pageId: this.page.pageId,
        pageName: this.page.pageName,
        pageConfig: this.page.pageConfig,
      };
      this.sharedService
        .updatePageData(pagePostData)
        .subscribe((data: any) => {});
    }
  }

  over(event: any) {
    const size = event.item.calculateSize(event.gridster);

    event.item.itemPrototype.$element.querySelector(
      ".gridster-item-inner"
    ).style.width = size.width + "px";
    event.item.itemPrototype.$element.querySelector(
      ".gridster-item-inner"
    ).style.height = size.height + "px";
    event.item.itemPrototype.$element.querySelector(
      ".gridster-item-inner"
    ).style["z-index"] = 1000;
    event.item.itemPrototype.$element.classList.add("is-over");
  }

  out(event: any) {
    event.item.itemPrototype.$element.querySelector(
      ".gridster-item-inner"
    ).style.width = "";
    event.item.itemPrototype.$element.querySelector(
      ".gridster-item-inner"
    ).style.height = "";
    event.item.itemPrototype.$element.classList.remove("is-over");
  }

  addWidgetFromDrag(event: any, data: WIDGET | FORMSI | any) {
    const item = event.item;
    if (data?.widgetType) {
      const widget: WIDGET = data;
      widget.widgetConfig!.dimentions!.x = item.x;
      widget.widgetConfig!.dimentions!.y = item.y;
      this.updateResponsiveOptions(
        widget.widgetConfig!.responsiveOptions,
        item.x,
        item.y
      );
      this.gridsterService.addWidgetToSelectedWidgets(widget, "addWidget");
    } else if (data.formConfig) {
      const form: FORMSI = data;
      form.formConfig!.dimentions!.x = item.x;
      form.formConfig!.dimentions!.y = item.y;
      this.updateResponsiveOptions(
        form.formConfig!.responsiveOptions,
        item.x,
        item.y
      );
      this.gridsterService.addWidgetToSelectedWidgets(form, "addForm");
    }
  }

  // Helper function to update responsive options
  updateResponsiveOptions(
    responsiveOptions: RESPONSIVEOPTIONSI,
    x: number,
    y: number
  ) {
    responsiveOptions.xMd = x;
    responsiveOptions.xLg = x;
    responsiveOptions.xSm = x;
    responsiveOptions.xXl = x;
    responsiveOptions.yLg = y;
    responsiveOptions.yMd = y;
    responsiveOptions.ySm = y;
    responsiveOptions.yXl = y;
    responsiveOptions.dragAndDrop = true;
    responsiveOptions.resizable = true;
  }

  toggleMenu() {
    this.webBuilderService.drawerToggle();
  }

  getDisplayContent() {
    this.sideNavSubscription =
      this.sharedService.sidenavContentlistSubject$.subscribe((option) => {
        if ("" != option.id) {
          this.openedContainers = [];
          this.displayedContent = option.id;
        }

        if (option.id == "") {
          this.displaySubNav = false;
        } else {
          this.displaySubNav = option.isActive;
        }

        // for Nav and side bar
        this.allPages = this.sharedService.getPages();
        if (option.id === this.sideNavContentOptions.menu && option.isActive) {
          this.pages.clear();
          this.menuConfig = this.page.pageConfig?.menuConfig;
          if (!this.menuConfig && this.page) {
            this.menuButtonGroup.patchValue({
              logo: "logo",
              userInfo: true,
              logoutOption: true,
            });
            this.allPages.forEach((page) => {
              if (
                [
                  this.pageTypes.customPage,
                  this.pageTypes.landingPage,
                ].includes(page.pageType)
              ) {
                this.pages.push(
                  this._fb.group({
                    name: [page.pageName],
                    enable: true,
                  })
                );
              }
            });

            this.page.pageConfig["menuConfig"] = this.menuButtonGroup.value;
            this.sharedService.setSelectedPage(this.page);
          } else {
            this.menuButtonGroup.patchValue({
              logo: this.menuConfig.logo,
              userInfo: this.menuConfig?.userInfo,
              logoutOption: this.menuConfig.logoutOption,
            });
            let updatedPagesList = this.modifyFormPagesList(
              this.menuConfig?.pages,
              this.allPages
            );
            updatedPagesList.forEach((page) => {
              this.pages.push(
                this._fb.group({
                  name: [page.name],
                  enable: page.enable,
                })
              );
            });
          }
        } else if (
          option.id === this.sideNavContentOptions.nav &&
          option.isActive
        ) {
          this.navConfig = this.page.pageConfig?.navConfig;
          this.navPages.clear();
          if (!this.navConfig && this.page) {
            this.navButtonGroup.patchValue({
              menuIcon: "menu",
              logo: "logo",
              title: "Title",
              userInfo: true,
              logoutOption: true,
            });
            this.allPages.forEach((page) => {
              if (
                [
                  this.pageTypes.customPage,
                  this.pageTypes.landingPage,
                ].includes(page.pageType)
              ) {
                this.navPages.push(
                  this._fb.group({
                    name: [page.pageName],
                    enable: true,
                  })
                );
              }
            });

            this.page.pageConfig["navConfig"] = this.navButtonGroup.value;
            this.sharedService.setSelectedPage(this.page);
          } else {
            this.navButtonGroup.patchValue({
              menuIcon: this.navConfig.menuIcon,
              logo: this.navConfig.logo,
              title: this.navConfig.title,
              userInfo: this.navConfig.userInfo,
              logoutOption: this.navConfig.logoutOption,
              selectedOption:this.navConfig.selectedOption,
            });
            let updatedPagesList = this.modifyFormPagesList(
              this.navConfig?.pages,
              this.allPages
            );
            updatedPagesList.forEach((page) => {
              this.navPages.push(
                this._fb.group({
                  name: [page.name],
                  enable: page.enable,
                })
              );
            });
          }
        }
      });
  }

  showContent(component: string) {
    this.displayedContent = component;
    this.openedContainers.push(component);
  }

  // this function is used to navigate back to a previously opened container;
  onBack() {
    this.openedContainers.pop();

    if (this.openedContainers.length < 1) {
      this.sharedService.setSidenavContentlistOption("", false);
    } else {
      let val = this.openedContainers[this.openedContainers.length - 1];
      this.sharedService.onMobileScreenClearData();
      if (val) this.displayedContent = val;
    }
  }

  ngOnDestroy() {
    this.sideNavSubscription.unsubscribe();
  }

  changePanelState(i: number) {
    this.panelStates.forEach((value) => {
      value = false;
    });
    this.panelStates[i] = !this.panelStates[i];
  }

  // Add Component

  applyFilter() {
    this.filteredCategories = [];
    if (this.searchTerm && this.searchTerm != "") {
      this.isFilterApplied = true;
      // Loop through each section in SECTION_META
      CATEGORIES_META_DATA.forEach((category: any) => {
        const filteredItems = category.items.filter((item: any) => {
          return item.name
            .toLowerCase()
            .includes(this.searchTerm.toLowerCase());
        });

        if (filteredItems.length > 0) {
          this.filteredCategories.push({
            ...category,
            items: filteredItems,
          });
        }
        this.panelStates = this.filteredCategories.map(() => true);
      });
    } else {
      this.isFilterApplied = false;
      this.filteredCategories = this.categoriesList;
      this.panelStates = this.panelStates.map(() => false);
    }
  }

  getImageUrl(item: any) {
    let path = "../assets/images/save_mob_icons/" + item.image + ".svg";
    return path;
  }

  getPageImageUrl(item: any) {
    let path = "../assets/images/save_mob_icons/" + item.icon + ".svg";
    return path;
  }

  onDragStart(event: DragEvent, item: FORMSI | SECTION | WIDGET): void {
    event.dataTransfer!.setData("text/plain", JSON.stringify(item));
    this.sharedService.setDisplayRestrictedArea(true);
  }

  onFileSelected(event: any) {
    const selectedFile = event.target.files[0];
    if (selectedFile) {
      //  let imageUploaderPhoto = selectedFile;
      const reader = new FileReader();

      reader.onload = (e: any) => {
        const image = new Image();
        image.src = e.target.result;

        image.onload = () => {
          this.imageUploaderSrc = e.target.result;
          const binaryData = e.target.result.split(",")[1];
          if (this.displayedContent === this.sideNavContentOptions.nav) {
            this.navButtonGroup.patchValue({
              logo: binaryData,
            });
            this.navConfig.logo = binaryData;
          } else {
            this.menuButtonGroup.patchValue({
              logo: binaryData,
            });
          }

          if (this.page.pageId) {
            this.sharedService.setSelectedPage(this.page);
          }
        };
      };
      reader.readAsDataURL(selectedFile);
    }
  }

  getImageFile(binaryImage: any) {
    if (binaryImage == "logo" || binaryImage == undefined) {
      return this.imageUploaderSrc;
    } else if (binaryImage.includes("mobiwise.s3")) {
      return binaryImage;
    } else {
      let imageSrc = "data:image/png;base64,";
      imageSrc = imageSrc + binaryImage;
      return imageSrc;
    }
  }

  updatePageData(currentItem: string) {
    if (currentItem === this.sideNavContentOptions.nav) {
      this.page.pageConfig["navConfig"] = this.navButtonGroup.value;
    } else {
      this.page.pageConfig["menuConfig"] = this.menuButtonGroup.value;
    }
    this.sharedService.setSelectedPage(this.page);
  }

  changeSubscribe() {
    this.menuButtonGroup.valueChanges
      .pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((formValue) => {
        if (this.displayedContent === this.sideNavContentOptions.menu) {
          this.updatePageData(this.sideNavContentOptions.menu);
        }
      });

    this.navButtonGroup.valueChanges
      .pipe(debounceTime(100), distinctUntilChanged())
      .subscribe((formValue) => {
        if (this.displayedContent === this.sideNavContentOptions.nav) {
          this.updatePageData(this.sideNavContentOptions.nav);
        }
      });
  }

  modifyFormPagesList(originalList: any[], pages: any[]): any[] {
    const updatedList: any[] = [];

    pages
      .filter((page) =>
        [this.pageTypes.customPage, this.pageTypes.landingPage].includes(
          page.pageType
        )
      )
      .map((page) => page.pageName)
      .forEach((name) => {
        const existingItem = originalList.find((page) => page.name === name);
        if (existingItem) {
          updatedList.push(existingItem);
        } else {
          updatedList.push({ name: name, enable: false });
        }
      });
    const filteredList = updatedList.filter(
      (item) => !pages.includes(item.name)
    );
    return filteredList;
  }
}
